import React from 'react';
// import { Link } from 'react-router';
// import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import {
    Modal,


} from 'react-bootstrap';
// import classNames from 'classnames';
// import validator from './../common/validator.js';
const autoBind = require('auto-bind');

const styleP = { fontSize: 14, fontWeight: 600, marginRight: 2 };
const styleS = { fontSize: 14, fontWeight: 400 };
const stylephone = { fontSize: 14, fontWeight: 400 };
import * as constant from '../../constants/constant';


class SpecialistLanguage extends React.Component {

    render() {
        let language = constant.SPECIALIST_PROFILE_LANGUAGE;
        const { initialLanguage } = this.props
        
        return <Modal show={this.props.isOpen} onHide={this.props.closeLanguageModal} closeButton >
            <Modal.Header closeButton>
                {/* <Modal.Close onClick={this.props.hideSigninModal} /> */}
                <Modal.Title>Select Language</Modal.Title>
                {/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
            </Modal.Header>
            <Modal.Body>
                {language.map((lang, index) => {
                    let specialistLang = initialLanguage && initialLanguage.includes(lang.name)
                    return <div> <div className="form-check" key={lang.id}>
                        <input className="form-check-input" checked={specialistLang} onChange={(e) => this.props.onSelect(e)} type="checkbox" value={lang.name} id={lang.name} />
                        <label className="form-check-label" htmlFor={lang.name}>
                            {lang.name}
                        </label>
                    </div>
                    </div>
                })}
                <div className="btnSubmit text-center" style={{ marginTop: "33px" }}>
                    <button className="btn btn-primary" onClick={() => this.props.closeLanguageModal()}>Save</button>&nbsp;
                        {/* <button className="btn btn-primary" onClick={this.props.closeLanguageModal}>Cancel</button> */}
                </div>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </Modal >
    }
}

export default SpecialistLanguage;




